@if (oidcSecurityService.authenticated().isAuthenticated) {
@defer {
<mdm-layout />
}
}